import { mapGetters } from 'vuex'

import format from '@/module/util/format'
import Columns from './column/components'
import QuestionnaireBucketMixin from '../../mixin/questionnaire-bucket'

export default {

	mixins: [QuestionnaireBucketMixin],

	props: {
		ascending: {
			type: Boolean,
			default: false
		},
		descending: {
			type: Boolean,
			default: false
		},
		/**
		 * Sort by type of most recent event first
		 */
		mostRecent: {
			type: Boolean,
			default: false
		},
		/**
		 * Sort by order of list that
		 * comes in profile object
		 */
		profileWise: {
			type: Boolean,
			default: false
		},
		/**
		 * Event Id in case of the
		 * questionnaire bucket being rendered
		 * Will be used to get profile for
		 * sorting
		 */
		eventId: {
			type: String,
			default: ''
		}
	},

	data() {
		return {
			expand: []
		}
	},

	methods: {
		...format,

		selectRow(row) {
			if (this.expand[0] == row.id)
				this.expand = []
			else
				this.expand = [ row.id ]
		},
		expandRow(row) {
			// if(this.isSurvey)
			// 	return
			if (this.expand.includes(row.id))
				this.expand.splice(this.expand.indexOf(row.id), 1)
			else
				this.expand.push(row.id)
		},
		expandSurveyRow(row) {
			if (this.expand.includes(row.id))
				this.expand.splice(this.expand.indexOf(row.id), 1)
			else
				this.expand.push(row.id)
		},
		typeMap(events) {
			if (! Array.isArray(events))
				return {}
			// Create a mapping of all event types
			var type = {}
			events.forEach((event) => {
				let t = event.type ? event.type.split(':')[1] : event.event
				if (! type[t])
					type[t] = {
						id: t,
						event: []
					}
				type[t].event.push(event)
			})

			// Sort all underlying events for each type
			var typeMap = Object.keys(type)
				.map((t) => {
					type[t].event = type[t].event.sort((a, b) => a.id.localeCompare(b.id))

					// Finding most recent answered events in every type, currently only for questionnaire
					if(this.mostRecent && this.questionnaire)
						type[t].mostRecent = type[t].event.reduce((recentEvent, event) => (event.requested && recentEvent < event.requested) ? event.requested : recentEvent, 0)
					return type[t]
				})

			// Sort each id into order by frequency or by most recent
			if(this.mostRecent && this.questionnaire)
				return typeMap.sort((a, b) => (b.mostRecent - a.mostRecent))
			// If we have to sort by profile order and we have `eventId`
			if(this.profileWise &&  this.eventId !== '' && this.questionnaire ) {
				const profileQuestionnaireOrder = this.getProfileQuestionaireOrder(this.eventId)
				if(profileQuestionnaireOrder.length > 0)
					return typeMap.sort((a, b) => this.sortByProfileOrder(a.id, b.id, profileQuestionnaireOrder))
				return typeMap
			}
			else if (this.ascending)
				return typeMap.sort((a, b) => (a.event.length - b.event.length))
			else if (this.descending)
				return typeMap.sort((a, b) => (b.event.length - a.event.length))
			else
				return typeMap
		},

		getProfileFromProvider(providerId, {profile_map, profile}) {
			if(profile_map) {
				const providerProfile = profile_map.find((providerProfile) => providerProfile.includes(providerId))
				if(providerProfile)
					return '(' + this.getContentKey('profile', providerProfile.split(':')[1], 'title') + ')'
			}
			else
				return '(' + this.getContentKey('profile', profile[0], 'title') + ')'
		}
	},

	computed: {
		...mapGetters('content', [
			'getContent',
			'getContentKey'
		]),
		...mapGetters('provider', [
			'allPatientsChosen',
			'getProviderNameById'
		])
	},

	components: {
		...Columns
	}
}
